import MyEMSParcelsContainer from "../containers/MyEMSParcelsContainer";

const MyEMSParcelsPage = () => {
    return <MyEMSParcelsContainer />;
};

export default MyEMSParcelsPage;
